import React from "react";
import "../App.css";
import "../sections/Skills.css";

const Skills = () => (
  <section id="skills" className="skills-section">
    <h1 id="skills-header">Skills</h1>

    <div className="skills-card">
      <div className="card-header">
        <i className="fa-solid fa-laptop-code icon"></i>
        <h3>What I can do</h3>
      </div>
      <p>
        I ensure software quality on mobile and web platforms through effective
        testing strategies.
      </p>
      <ul>
        <li>Manual & Automated Testing</li>
        <li>Functional, Regression & Performance Testing</li>
        <li>API Testing and Automation</li>
        <li>Agile & Scrum Team Collaboration</li>
        <li>Test Planning and Risk Analysis</li>
        <li>Quality Reporting and Metrics</li>
      </ul>
    </div>

    <div className="skills-card">
      <div className="card-header">
        <i className="fa-solid fa-layer-group icon"></i>
        <h3>Tools I Use</h3>
      </div>
      <p>
        I work with industry-standard tools to deliver thorough and scalable QA
        solutions:
      </p>
      <ul id="skills-tools-list">
        <li>
          <strong>Testing Tools: </strong>Selenium, Appium, Cypress, JMeter,
          Katalon Studio
        </li>
        <li>
          <strong>API Testing: </strong>Postman, REST Assured
        </li>
        <li>
          <strong>Frameworks & Languages: </strong> Java, JavaScript, HTML, CSS
        </li>
        <li>
          <strong>Project & Test Managemen: </strong> JIRA, Confluence, TestRail
        </li>
      </ul>
    </div>
  </section>
);

export default Skills;
